<template>
  <div class="md-layout">
    <md-autocomplete
      v-model="selectedSensor"
      md-dense
      :md-options="sensores"
      :disabled="loading || sending"
      :required="required"
      :class="getValidationClass()"
      @md-changed="handleChange"
      @md-closed="handleClose"
    >
      <label>{{ label }}</label>
      <template slot="md-autocomplete-item" slot-scope="{ item, term }">
        <md-highlight-text :md-term="term">
          {{ item }}
        </md-highlight-text>
      </template>

      <template slot="md-autocomplete-empty" slot-scope="{ term }">
        Nenhum sensor correspondente a "{{ term }}" foi encontrado.
      </template>

      <span v-if="validation && !validation.required" class="md-error">
        {{ label }} é obrigatório
      </span>
    </md-autocomplete>
  </div>
</template>

<script>
import http from '@/utils/http'

export default {
  name: 'SensorAutocomplete',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    localId: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: 'Sensor',
    },
    value: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: Object,
      default: null,
    },
    sending: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sensores: [],
      selectedSensor: null,
      loading: false,
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(sensorId) {
        this.updateSelectedSensor(sensorId)
      },
    },
    sensores() {
      this.$nextTick(() => {
        this.updateSelectedSensor(this.value)
      })
    },
  },
  mounted() {
    this.fetchSensores()
  },
  methods: {
    updateSelectedSensor(sensorId) {
      if (sensorId === null) return (this.selectedSensor = null)
      this.selectedSensor =
        this.sensores.find((s) => s.sensorId === sensorId) || null
    },
    getValidationClass() {
      if (!this.validation) return
      return {
        'md-invalid': this.validation.$invalid && this.validation.$dirty,
      }
    },
    async fetchSensores() {
      this.loading = true
      try {
        const { equipamentos } = await http.get(
          `local/${this.localId}/equipamentos`
        )
        this.sensores = equipamentos.flatMap((equipamento) => {
          return equipamento.sensores.map((sensor) => {
            const sensorDescricao = `${equipamento.nome} - ${
              sensor.descricao || sensor.codigoIntegracao
            }`

            return {
              sensorId: sensor.id,
              sensorDescricao,
              toLowerCase: () => sensorDescricao.toLowerCase(),
              toString: () => sensorDescricao,
            }
          })
        })
      } catch (error) {
        console.error('Erro ao buscar sensores:', error)
      } finally {
        this.loading = false
      }
    },
    handleChange() {
      this.$emit(
        'input',
        typeof this.selectedSensor === 'object'
          ? this.selectedSensor.sensorId
          : null
      )
    },
    async handleClose() {
      // Delay to allow the input to update before clearing
      await new Promise((resolve) => setTimeout(resolve, 300))
      if (typeof this.selectedSensor === 'object') return
      this.selectedSensor = null
    },
  },
}
</script>
